module.exports = window.Highcharts;